import React from "react"
import {Link} from "gatsby";

export default function FollowUsAndScrollToTop() {
    return (
        <>
            <div
                className="sticky-wrap z-index-1 d-none d-xl-inline-block"
                data-animation-delay={100}
                data-shadow-animation="true"
            >
                <div className="elements-social social-icon-style-10">
                    <ul className="small-icon dark fw-600">
                        <li className="fs-18">
                            Follow us{" "}
                            <span className="separator-line-1px w-30px bg-dark-gray d-inline-block align-middle ms-15px" />
                        </li>
                        <li>
                            <a
                                className="linkedin"
                                href="https://www.linkedin.com/company/matrixbrains/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                In.
                            </a>{" "}
                        </li>
                        <li>
                            <a
                                className="twitter"
                                href="https://x.com/matrixbrains"
                                target="_blank"
                                rel="noreferrer">
                                X.
                            </a>
                        </li>
                        <li>
                            <a
                                className="instagram"
                                href="https://www.instagram.com/matrixbrains"
                                target="_blank"
                                rel="noreferrer">
                                Ig.
                            </a>{" "}
                        </li>
                    </ul>
                </div>
            </div>

            <div className="scroll-progress d-none d-xxl-block">
                <Link to="#" role="button" className="scroll-top" aria-label="scroll">
                    <span className="scroll-text">Scroll to top</span>
                    <span className="scroll-line">
                        <span className="scroll-point" />
                    </span>
                </Link>
            </div>
        </>
    )
}